import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { SortModel } from '../../models/filters/sort.model';
import { PaymentMethod } from '../../../../enums/payment-method.enum';
import { FilterModel } from '../../models/filters/filters.model';

@Injectable({
  providedIn: 'root',
})
export class InvoicesService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  invoiceList(
    page: number,
    size: number,
    filters?: FilterModel[],
    sort?: SortModel
  ): Observable<any> {
    let url = `${
      environment.apiLocations.patient
    }/PatientInvoice/PendingInvoiceList?PageRequest.PageIndex=${
      page - 1
    }&PageRequest.PageSize=${size}`;

    if (filters) {
      const resultFilter = filters.filter((x) => !!x.value);
      url += resultFilter.map((f) => `&${f.filterId}=${f.value}`).join('');
    }
    if (sort) {
      url += `&SortBy=${sort.column}&SortDescending=${
        sort.orderBy == 'descending'
      }`;
    }

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  createInvoiceReport(patientRecordId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientInvoice/CreateInvoiceForPatient/${patientRecordId}`;

    return this.http.post<any>(
      url,
      { patientRecordId },
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }

  checkInvoiceReport(
    patientRecordId: string,
    fileName: string
  ): Observable<any> {
    let url = `${environment.apiLocations.invoice}/Invoice/CheckInvoiceCreated/${patientRecordId}/${fileName}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  invoiceReport(patientRecordId: string, fileName: string): Observable<any> {
    let url = `${environment.apiLocations.invoice}/Invoice/GetInvoicePdf/${patientRecordId}/${fileName}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  updatePaymentMethod(
    patientRecordId: string,
    form: { patientRecordId: string; paymentMethod: PaymentMethod }
  ): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecord/UpdatePaymentMethod/${patientRecordId}`;

    return this.http.put<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  sendInvoice(patientRecordId: string): Observable<any> {
    let url = `${environment.apiLocations.patient}/PatientRecord/SendInvoiceToPatient`;
    const form = {
      patientRecordId,
    };

    return this.http.post<any>(url, form, {
      headers: this.headerHelperService.getHeaders(),
    });
  }
}
